import React, { useCallback, useEffect, useState } from "react";
import BreadCumb from "../../Component/BreadCumb";
import { Link, useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import { getAllCourse, deleteCourse, duplicateCourse } from "../../Libs/api";
import Loader from "../../Component/Loader";
import Swal from "sweetalert2";
import EditButton from "../../Component/EditButton";
import DeleteButton from "../../Component/DeleteButton";
import { Pagination } from "antd";
import moment from "moment/moment";

const CourseList = () => {
  const navigate = useNavigate();
  const [showFilter, setShowFilter] = useState(false);
  const [loading, setloading] = useState(false);
  const [allCourse, setAllCourse] = useState([]);
  const [limit, setLimit] = useState(10);
  const [offset, setOffset] = useState(0);
  const [totalCount, setTotalCount] = useState(0);
  const callAPI = useCallback(async (limit, offset) => {
    try {
      setloading(true);
      const apiCall = await getAllCourse({ limit, offset });
      if (apiCall.status) {
        setAllCourse(apiCall?.data?.rows);
        setTotalCount(apiCall?.data?.count);
        setloading(false);
      } else {
        toast.error(apiCall?.message);
      }
    } catch (error) {
      console.log(error);
      toast.error(error);
    }
    // eslint-disable-next-line
  }, []);

  useEffect(() => {
    callAPI(limit, offset);
    // eslint-disable-next-line
  }, [callAPI, limit, offset]);

  const handleDelete = async (id) => {
    await Swal.fire({
      title: "Are you sure?",
      text: "You won't be able to revert this!",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#d33",
      cancelButtonColor: "#3085d6",
      confirmButtonText: "Yes!",
    }).then(async (result) => {
      if (result.isConfirmed) {
        let formData = {
          id: id,
        };

        setloading(true);

        try {
          const apiCall = await deleteCourse(formData);
          if (apiCall.status) {
            console.log(apiCall, "apiCall");

            callAPI(limit, offset);
          } else {
            setloading(false);
            toast.error(apiCall?.message);
          }
        } catch (error) {
          setloading(false);
          console.log(error);
          toast.error(error);
        }
      }
    });
  };

  const handleOnChange = (page) => {
    console.log("page: ", page);
    setOffset(page * limit - limit);
  };

  const handleChangeSize = (current, size) => {
    setOffset(0);
    setLimit(size);
  };

  const handleDuplicate = async (id) => {
    let formData = {
      id: id,
    };

    setloading(true);

    try {
      const apiCall = await duplicateCourse(formData);
      if (apiCall.status) {
        console.log(apiCall, "apiCall");

        callAPI(limit, offset);
      } else {
        setloading(false);
        toast.error(apiCall?.message);
      }
    } catch (error) {
      setloading(false);
      console.log(error);
      toast.error(error);
    }
  };

  if (loading) {
    return <Loader />;
  }
  return (
    <div class="page-body">
      <BreadCumb title={"Course List"} subtitle={"General"} />
      <div class="container-fluid">
        <div class="row">
          <div class="col-sm-12">
            <div class="card">
              <div class="card-body">
                <div class="list-product-header">
                  <div>
                    {/* <div class="light-box">
                      <Link
                        onClick={() => {
                          setShowFilter(!showFilter);
                        }}
                        role="button"
                        aria-expanded="false"
                        aria-controls="collapseProduct"
                      >
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          width="24"
                          height="24"
                          viewBox="0 0 24 24"
                          fill="none"
                          stroke="currentColor"
                          stroke-width="2"
                          stroke-linecap="round"
                          stroke-linejoin="round"
                          class="feather feather-filter filter-icon show"
                        >
                          <polygon points="22 3 2 3 10 12.46 10 19 14 21 14 12.46 22 3"></polygon>
                        </svg>
                        <i class={"icon-close filter-close hide"}></i>
                      </Link>
                    </div> */}
                    <Link class="btn btn-primary" to="/addcourse">
                      <i class="fa fa-plus"></i>Add Course
                    </Link>
                  </div>
                  <div
                    class={`collapse ${showFilter ? "show" : ""}`}
                    id="collapseProduct"
                  >
                    <div class="card card-body list-product-body">
                      <div class="row row-cols-xl-5 row-cols-lg-4 row-cols-md-3 row-cols-sm-2 row-cols-2 g-3">
                        <div class="col">
                          <select
                            class="form-select"
                            aria-label="Default select example"
                          >
                            <option selected="">Choose Product</option>
                            <option value="1">Apple iphone 13 Pro</option>
                            <option value="2">Wood Chair</option>
                            <option value="3">
                              M185 Compact Wireless Mouse
                            </option>
                          </select>
                        </div>
                        <div class="col">
                          <select
                            class="form-select"
                            aria-label="Default select example"
                          >
                            <option selected="">Choose Category</option>
                            <option value="1">Furniture</option>
                            <option value="2">Smart Gadgets</option>
                            <option value="3">Electrics</option>
                          </select>
                        </div>
                        <div class="col">
                          <select
                            class="form-select"
                            aria-label="Default select example"
                          >
                            <option selected="">Choose Sub Category</option>
                            <option value="1">Smart Phones</option>
                            <option value="2">Smart Watches</option>
                            <option value="3">Wireless headphone</option>
                          </select>
                        </div>
                        <div class="col">
                          <select
                            class="form-select"
                            aria-label="Default select example"
                          >
                            <option selected="">Status</option>
                            <option value="1">Sold Out</option>
                            <option value="2">In Stock</option>
                            <option value="3">Pre Order</option>
                            <option value="4">Limited Stock</option>
                          </select>
                        </div>
                        <div class="col">
                          <select
                            class="form-select"
                            aria-label="Default select example"
                          >
                            <option selected="">Price</option>
                            <option value="1">56000.00</option>
                            <option value="2">19000.00</option>
                            <option value="3">10000.00</option>
                            <option value="3">15000.00</option>
                            <option value="3">99000.00</option>
                          </select>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="list-product">
                  <div class="datatable-wrapper datatable-loading no-footer sortable searchable fixed-columns">
                    <div class="datatable-container">
                      <table class="table datatable-table" id="project-status">
                        <thead>
                          <tr>
                            <th data-sortable="true" style={{ width: "25%" }}>
                              <span class="f-light f-w-600">Title </span>
                            </th>
                            <th data-sortable="true" style={{ width: "10%" }}>
                              <span class="f-light f-w-600">Durations </span>
                            </th>
                            <th data-sortable="true" style={{ width: "15%" }}>
                              <span class="f-light f-w-600">Group Size</span>
                            </th>
                            <th data-sortable="true" style={{ width: "15%" }}>
                              <span class="f-light f-w-600">
                                Software Provided
                              </span>
                            </th>
                            <th data-sortable="true" style={{ width: "10%" }}>
                              <span class="f-light f-w-600">Syllabus</span>
                            </th>
                            <th data-sortable="true" style={{ width: "10%" }}>
                              <span class="f-light f-w-600">Created At</span>
                            </th>
                            <th style={{ width: "5%" }}>
                              <span class="f-light f-w-600">status</span>
                            </th>
                            <th data-sortable="true" style={{ width: "10%" }}>
                              <span class="f-light f-w-600">Action</span>
                            </th>
                          </tr>
                        </thead>
                        <tbody>
                          {allCourse?.map((item, i) => {
                            return (
                              <tr key={i} data-index={i}>
                                <td>
                                  <div class="product-names">
                                    <div class="light-product-box">
                                      <img
                                        class="img-fluid"
                                        src={item?.images}
                                        alt="laptop"
                                      />
                                    </div>
                                    <p>{item?.name}</p>
                                  </div>
                                </td>
                                <td>
                                  <p class="f-light">{item?.durations}</p>
                                </td>
                                <td>
                                  <p class="f-light">{item?.groupSize}</p>
                                </td>
                                <td>
                                  <p class="f-light">
                                    {item?.softwareProvided}
                                  </p>
                                </td>
                                <td>
                                  <p class="f-light">{item?.syllabus}</p>
                                </td>
                                <td>
                                  <p class="f-light">
                                    {moment(item?.createdAt).format(
                                      "DD-MM-YYYY HH:MM A"
                                    )}
                                  </p>
                                </td>
                                <td>
                                  <div
                                    className={`status-badge status-${
                                      item?.status ? "active" : "inactive"
                                    }`}
                                  >
                                    <span>
                                      {item?.status ? "Active" : "Inactive"}
                                    </span>
                                  </div>
                                </td>
                                <td>
                                  <div class="product-action">
                                    <svg
                                      xmlns="http://www.w3.org/2000/svg"
                                      id="Layer_1"
                                      height="512"
                                      viewBox="0 0 24 24"
                                      class="iconify iconify--solar minimal__iconify__root css-1bkxjvr"
                                      width="512"
                                      data-name="Layer 1"
                                      style={{ cursor: "pointer" }}
                                      onClick={() => {
                                        handleDuplicate(item?.id);
                                      }}
                                    >
                                      <path d="m13 4a1 1 0 0 0 1 1h3.966a2.981 2.981 0 0 0 -.811-1.728l-2.284-2.359a3.011 3.011 0 0 0 -1.871-.884zm-2 0v-4h-4a5.006 5.006 0 0 0 -5 5v10a5.006 5.006 0 0 0 5 5h6a5.006 5.006 0 0 0 5-5v-8h-4a3 3 0 0 1 -3-3zm6 20h-9a1 1 0 0 1 0-2h9a3 3 0 0 0 3-3v-11a1 1 0 0 1 2 0v11a5.006 5.006 0 0 1 -5 5z" />
                                    </svg>

                                    <EditButton
                                      onClickFunction={() => {
                                        navigate("/editcourse", {
                                          state: item,
                                        });
                                      }}
                                    />
                                    <DeleteButton
                                      onClickFunction={() => {
                                        handleDelete(item?.id);
                                      }}
                                    />
                                  </div>
                                </td>
                              </tr>
                            );
                          })}
                        </tbody>
                      </table>
                    </div>
                  </div>
                </div>
                <div className="mt-4 d-flex justify-content-end">
                  <Pagination
                    defaultCurrent={1}
                    total={totalCount}
                    defaultPageSize={limit}
                    current={offset / limit + 1}
                    onChange={handleOnChange}
                    showSizeChanger={true}
                    onShowSizeChange={handleChangeSize}
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default CourseList;
